import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMaintenance: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMaintenance"><Path d="M14 6L17.4132 2.5868C16.5176 2.20891 15.5332 2 14.5 2C10.3579 2 7 5.35786 7 9.5C7 10.5332 7.20891 11.5176 7.5868 12.4132L2 18L6 22L11.5868 16.4132C12.4824 16.7911 13.4668 17 14.5 17C18.6421 17 22 13.6421 22 9.5C22 8.46683 21.7911 7.48244 21.4132 6.5868L18 10C16.8954 11.1046 15.1046 11.1046 14 10C12.8954 8.89543 12.8954 7.10457 14 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMaintenance;
